import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cur } from '@/lib/currency';

export default function HeroSalesCard({ todaySales, ordersCount, trendPct, currency = cur() }) {
  const fmt = (v) => (v || 0).toLocaleString('ar-EG', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

  const trendUp = trendPct > 0;
  const trendDown = trendPct < 0;
  const TrendIcon = trendUp ? TrendingUp : trendDown ? TrendingDown : Minus;
  const trendColor = trendUp ? 'text-emerald-400' : trendDown ? 'text-red-400' : 'text-slate-400';
  const trendBg = trendUp ? 'bg-emerald-500/20' : trendDown ? 'bg-red-500/20' : 'bg-slate-500/20';

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary to-blue-700 p-6 text-white shadow-xl shadow-primary/30">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-8 -left-8 w-48 h-48 rounded-full bg-white/5" />
        <div className="absolute -bottom-12 -right-12 w-64 h-64 rounded-full bg-white/5" />
      </div>

      <div className="relative z-10">
        <p className="text-white/70 text-sm font-medium mb-1">مبيعات اليوم</p>
        <div className="flex items-end gap-3 mb-3">
          <span className="text-4xl md:text-5xl font-black tracking-tight leading-none">
            {fmt(todaySales)}
          </span>
          <span className="text-lg text-white/70 mb-1">{currency}</span>
        </div>

        <div className="flex items-center gap-4">
          <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full ${trendBg}`}>
            <TrendIcon className={`w-3.5 h-3.5 ${trendColor}`} />
            <span className={`text-xs font-bold ${trendColor}`}>
              {trendPct > 0 ? '+' : ''}{trendPct.toFixed(1)}% مقارنة بأمس
            </span>
          </div>
          <div className="text-white/60 text-xs">
            {ordersCount} طلب
          </div>
        </div>
      </div>
    </div>
  );
}